import { FACTORS, SERIES } from "./graphModel";

const LineSample = ({ factor }) => (
  <svg width="24" height="8" className="ludograph-line-sample">
    <line
      x1="0"
      y1="4"
      x2="24"
      y2="4"
      style={{ stroke: factor.color, strokeWidth: 2.5, strokeDasharray: factor.dash }}
    />
  </svg>
);

const WeightPanel = ({
  weights,
  shares,
  onWeight,
  seriesWeight,
  onSeriesWeight,
  threshold,
  onThreshold,
  maxLinks,
  clusters,
  activeCluster,
  onCluster,
  stats,
}) => (
  <aside className="ludograph-left">
    <section className="ludograph-section ludograph-weights">
      <div>
        <h6>Connection weighting</h6>
        <p className="ludograph-muted">
          How much each factor counts toward a link. The graph re-settles as you drag.
        </p>
      </div>
      <div className="ludograph-factor">
        <div className="ludograph-factor-head">
          <LineSample factor={SERIES} />
          <span className="ludograph-factor-label">{SERIES.label}</span>
          <span className="ludograph-num">{seriesWeight ? `${seriesWeight}%` : "Off"}</span>
        </div>
        <input
          type="range"
          min="0"
          max="100"
          value={seriesWeight}
          onChange={(e) => onSeriesWeight(+e.target.value)}
          aria-label={`${SERIES.label} weight`}
        />
        <p className="ludograph-muted ludograph-small">
          Games in the same series always score at least this much.
        </p>
      </div>
      {FACTORS.map((f) => (
        <div className="ludograph-factor" key={f.key}>
          <div className="ludograph-factor-head">
            <LineSample factor={f} />
            <span className="ludograph-factor-label">{f.label}</span>
            <span className="ludograph-num">{shares[f.key]}%</span>
          </div>
          <input
            type="range"
            min="0"
            max="100"
            value={weights[f.key]}
            onChange={(e) => onWeight(f.key, +e.target.value)}
            aria-label={`${f.label} weight`}
          />
        </div>
      ))}
      <p className="ludograph-muted ludograph-small">
        Line style shows the factor that contributes most to each link.
      </p>
    </section>

    <section className="ludograph-section ludograph-threshold">
      <div className="ludograph-row-baseline">
        <h6>Minimum link strength</h6>
        <span className="ludograph-num">{threshold}%</span>
      </div>
      <input
        type="range"
        min="5"
        max="80"
        value={threshold}
        onChange={(e) => onThreshold(+e.target.value)}
        aria-label="Minimum link strength"
      />
      <p className="ludograph-muted ludograph-small">
        Each game keeps up to {maxLinks} of its strongest links.
      </p>
    </section>

    <section className="ludograph-section ludograph-clusters">
      <h6>Clusters</h6>
      {clusters.map((c) => (
        <button
          key={c.id}
          className={`ludograph-cluster${activeCluster === c.id ? " is-active" : ""}`}
          onClick={() => onCluster(c.id)}
        >
          <span className="ludograph-cluster-size">{c.size}</span>
          <span className="ludograph-cluster-name">{c.name}</span>
          <span />
          <span className="ludograph-cluster-preview">{c.preview}</span>
        </button>
      ))}
    </section>

    <div className="ludograph-stats">
      <div>
        <div className="ludograph-stat-value">{stats.games}</div>
        <div className="ludograph-stat-label">Games</div>
      </div>
      <div>
        <div className="ludograph-stat-value">{stats.links}</div>
        <div className="ludograph-stat-label">Links</div>
      </div>
      <div>
        <div className="ludograph-stat-value">{stats.isolated}</div>
        <div className="ludograph-stat-label">Unlinked</div>
      </div>
    </div>
  </aside>
);

export default WeightPanel;
